module.exports = "<pre><code class=\"hljs html\"><span class=hljs-tag>&lt;<span class=hljs-name>focus-trap</span> <span class=hljs-attr>modifier</span>=<span class=hljs-string>\"primary\"</span>&gt;</span><span class=hljs-tag>&lt;/<span class=hljs-name>focus-trap</span>&gt;</span>\n</code></pre> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src-docs/app/snippets/primary-example.md
 ** module id = 74
 ** module chunks = 1
 **/